import deployment from '../config/hetzner-runtime.json';
import {paymentPageMetadata} from '../src/payment-page-metadata';
import designPreviews from '../config/design-previews.json';
import desktopPages from '../config/desktop-page-metadata.json';

const defaultDescription='AI teammates you can put to work. Give your bots a task. They research, write, plan and build. Follow their work and keep the results in your own workspace.';

/** Query parameters retain signup/selection state but never create canonical pages. */
export function setPublicUrlMetadata(path:string,publicPage:boolean):void{
  const desktopPage = desktopPages.find(page => page.path === path);
  if (desktopPage) publicPage = false;
  const preview = Object.values(designPreviews).find(item => item.path === path);
  document.head.querySelectorAll('link[data-design-language]').forEach(element => element.remove());
  if (preview) for (const language of Object.values(designPreviews).filter(item => item.design === preview.design)) {
    const alternate = document.createElement('link');
    alternate.rel = 'alternate'; alternate.hreflang = language.locale; alternate.href = new URL(language.path, deployment.url).href;
    alternate.dataset.designLanguage = language.locale; document.head.append(alternate);
  }
  let canonical=document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if(publicPage){
    if(!canonical){canonical=document.createElement('link');canonical.rel='canonical';document.head.append(canonical);}
    canonical.href=new URL(path,deployment.url).href;
  }else canonical?.remove();
  let robots=document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if(!robots){robots=document.createElement('meta');robots.name='robots';document.head.append(robots);}
  robots.content=publicPage?'index,follow':'noindex,nofollow';
  const payment=publicPage?paymentPageMetadata(path,deployment.url):null;
  const meta=(key:string,value:string,property=false)=>{
    const attribute=property?'property':'name';
    let element=document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
    if(!element){element=document.createElement('meta');element.setAttribute(attribute,key);document.head.append(element);}
    element.content=value;
  };
  document.getElementById('payment-page-data')?.remove();
  if(payment){
    document.title=payment.title;
    meta('description',payment.description);meta('og:title',payment.title,true);meta('og:description',payment.description,true);
    meta('og:url',payment.url,true);meta('og:type','website',true);meta('twitter:card','summary');
    meta('twitter:title',payment.title);meta('twitter:description',payment.description);
    const data=document.createElement('script');data.id='payment-page-data';data.type='application/ld+json';data.textContent=JSON.stringify(payment.structuredData);document.head.append(data);
  }else{
    if (desktopPage) document.title = desktopPage.title;
    meta('description',desktopPage ? desktopPage.description : path === '/' ? designPreviews.home.description : preview ? preview.description : defaultDescription);
    document.head.querySelectorAll('meta[property^="og:"],meta[name^="twitter:"]').forEach(element=>element.remove());
  }
}
